import React from 'react'
import './NotFound404.css'
import { useTranslation } from 'react-i18next'

function NotFound404() {
  const { t } = useTranslation(['global'])

  return (
    <div id="not-found-container">
      <div id="not-found">
        <i id="not-found-icon" className="fas fa-question-circle"></i>
          <span>{t('notfound404')}</span>
      </div>
    </div>
  )
}

export default NotFound404
